import { NIVEAU_OUTPUT } from '../../helpers/dashboard/buildBenchmarkRows'
import telwoord from '../../helpers/intelligence/telwoord'

/**
 * Eén benchmarkrij: omvang, oordeel over de klantdrempel, wat er nog nodig is,
 * de waarde met eenheid en het sterktelabel.
 *
 * Gedeeld door het themadetail (de benchmark van één effect) en de tabbladen
 * Outputs en Materialen, zodat 'drempel gehaald' overal hetzelfde leest.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * Geen sterktescore (materialen) is geen 'niet gehaald': zo'n rij krijgt géén
 * oordeel, want dat zou er óók een zijn.
 *
 * @param {object} props
 * @param {import('../../helpers/intelligence/buildBenchmarkOverview').BenchmarkOverviewRow} props.row - Rij uit buildBenchmarkOverview
 * @param {Array<string>} [props.tags] - Labels onder de naam; leeg = geen tagregel
 * @param {((row: object) => void)|null} [props.onOpen] - Maakt de rij een knop naar een detailpagina
 */
const BenchmarkRow = ({ row, tags = [], onOpen = null }) => {
    const inhoud = (
        <>
            <span className="intelligence-agenda-row__body">
                <span className="intelligence-agenda-row__title">{row.effectName}</span>
                {tags.length > 0 && (
                    <span className="intelligence-benchmark__tags">
                        {tags.map((tag) => <span key={tag} className="intelligence-tag">{tag}</span>)}
                    </span>
                )}
                {/* Een niveau-benchmark (materialen) telt huishoudens: daar vult
                    niemand iets in, dus 'respondenten' zou onwaar zijn. */}
                <span className="intelligence-agenda-row__stand">
                    {telwoord(row.companyCount, 'organisatie', 'organisaties')},{' '}
                    {row.kind === NIVEAU_OUTPUT
                        ? telwoord(row.respondentCount, 'huishouden', 'huishoudens')
                        : telwoord(row.respondentCount, 'respondent', 'respondenten')}
                </span>
                {!row.judgeable && (
                    <span className="intelligence-agenda-row__stand">
                        Geen sterkte-oordeel: het benchmarkmodel laat open welke teleenheid hier telt.
                    </span>
                )}
                {row.judgeable && row.thresholdMet && (
                    <span className="intelligence-badge intelligence-badge--ready">drempel gehaald</span>
                )}
                {row.judgeable && !row.thresholdMet && (
                    <span className="intelligence-agenda-row__gap">{row.gapText}</span>
                )}
            </span>
            <span className="intelligence-benchmark__waarde">{row.valueText}</span>
            <span className="intelligence-benchmark__sterkte">{row.strengthLabel || '—'}</span>
        </>
    )

    // Met een detailpagina is de hele rij één knop. Daarom alleen spans: een
    // `<p>` binnen een knop is ongeldige HTML.
    // AI-CONTEXT: See docs/pitfalls.md#ui-heading-inside-button-stops-being-a-heading
    if (onOpen) {
        return (
            <button type="button" className="intelligence-agenda-row intelligence-agenda-row--link" onClick={() => onOpen(row)}>
                {inhoud}
            </button>
        )
    }
    return <div className="intelligence-agenda-row">{inhoud}</div>
}

export default BenchmarkRow
